import { GridHalf, PageGrid, Window } from '@/components/base/Grid';

/** Visual return to the Hero: charcoal statement + large window onto the same world. */
export default function Closing() {
  return (
    <PageGrid label="Within reach" dark>
      <GridHalf className="bg-primary-500 text-background-50 cell flex flex-col justify-between gap-16 lg:min-h-[78svh]">
        <div className="flex items-center justify-between t-label text-background-400 reveal">
          <span className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-accent-500" />R / Radius</span>
          <span>Fig. 05</span>
        </div>
        <div className="reveal">
          <p className="t-edit max-w-[560px]">Every search has a radius.</p>
          <p className="t-edit text-accent-500 max-w-[560px]">Be inside it.</p>
          <a href="#contact" className="group mt-10 inline-flex items-center gap-2 text-[15px] min-h-[44px] cursor-pointer whitespace-nowrap">
            <span className="border-b border-accent-500 pb-0.5 group-hover:text-accent-400 transition-colors duration-200">Start a conversation</span>
            <i className="ri-arrow-right-down-line arrow-nudge" aria-hidden="true" />
          </a>
        </div>
      </GridHalf>
      <Window className="half-r min-h-[360px] md:min-h-[460px]" tag="Fig. 05 — The same field" caption="Local visibility field" meta="R / 06" />
    </PageGrid>
  );
}